import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-apireference',
  templateUrl: './apireference.component.html',
  styleUrls: ['./apireference.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})

export class ApireferenceComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  
  }

}
